import React, {ReactElement} from "react"
import {Dispute} from "../../resources/dispute"
import {Resource} from "../../resources/common"
import {AllowedDisputesColumns} from "./Disputes.types"
import {Meta} from "../../resources/common"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import classNames from "classnames"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import DisputeRow from "./DisputesTableRow"

interface DisputesTableProps {
	disputes: Array<Dispute>
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: Array<AllowedDisputesColumns>
	meta?: Meta
	token?: string
	refresh: () => void
	fullHeight?: boolean
	singleDisputeView?: boolean
}

export default function DisputesTable({
	disputes,
	includedColumns,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	include,
	meta,
	fullHeight,
	singleDisputeView,
}: DisputesTableProps): ReactElement {
	const noContent = disputes.length === 0

	return (
		<div className={classNames("disputes-table", singleDisputeView && "single-disputes-table")}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				noContentText={"No disputes found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{disputes.map((d) => (
						<DisputeRow
							includedColumns={includedColumns}
							key={d.id}
							dispute={d}
							include={include}
							showCustomerId={true}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
